import {
  CapSMSMailService,
  RequestType,
} from "./../../../service/capsmsmail/cap-smsmail.service";
import {
  Component,
  OnInit,
  ModuleWithComponentFactories,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import { formatDate } from "@angular/common";
import * as moment from "moment";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { DatePipe } from "@angular/common";
import { AwsService } from "../../../providers/appsyncservice/aws.service";
import { UserTypePipePipe } from "../../../pipes/user-type-pipe.pipe";
import { positions } from "../../../models/positions";
declare var google: any;
import * as XLSX from "xlsx";
import * as jsPDF from "jspdf";
import { UserDetailsService } from "../../../service/userdetails/user-details.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { AppConstants } from "../../../constants/app-constants";
import { DateutilService } from "./../../../service/dateutil/dateutil.service";
import { AwsAppServiceProvider } from "../../../providers/appsyncservice/ca.aws.notification.services";
import { Action } from "rxjs/internal/scheduler/Action";
import { Router } from "@angular/router";

export interface pushNotification {
  token?: string;
  notification?: {
    title?: string;
    body?: string;
  };
  android: {
    notification: {
      click_action: string;
    };
  };
  apns: {
    headers: {
      "apns-priority": string;
    };
    payload: {
      aps: {
        category: string;
      };
    };
  };
  data?: {
    icon: string;
    navigationTo: string;
    content: string;
    did: string;
    cp_header: string;
    request_id?: string
  };
}


@Component({
  selector: "app-car-main-request",
  templateUrl: "./car-main-request.component.html",
  styleUrls: ["./car-main-request.component.css"],
})
export class CarMainRequestComponent implements OnInit, AfterViewInit {
  @ViewChild("DatePicker") d1: ElementRef;
  displayValue: Number = 0;
  carReqlist: any = [];
  carMainModalBox: any = [];
  carRequestFm: FormGroup;
  statusFilterFm: FormGroup;
  carFeedBackBox: any = [];
  submitted = false;
  rowID: any;
  mymodel: any;
  statusComp: any;
  comments: any = [];
  userInfo: any = [];
  car_info: any = [];
  status: any = [
    { id: 2, name: "ACKNOWLEDGED" },
    { id: 3, name: "REJECTED" },
    { id: 4, name: "IN_PROGRESS" },
    { id: 5, name: "COMPLETED" },
  ];

  editDataView: any = {};
  DataView: any = {};

  clientSideStore: any = [];
  masterCarReqlist: any[] = [];
  setDateToGo: number;
  sortKey: string = "sno"; //set default
  sortReverse: boolean = false;
  minDate: any;
  noOfItems = 10;
  pagenationNextToken = "";
  total = 100;
  that: any;
  isnextBtn: boolean = false;
  isprevBtn: boolean = true;
  isPagenationFlag: boolean = false;
  current_page: any = 1;
  storedRecordInitialLength: number;
  snoFilterModel: any = new Array();
  createdTypeFilterModel: any = new Array();
  TicketIdFilterModel: any = new Array();
  usernameFilterModel: any = new Array();
  nameFilterModel: any = new Array();
  vehNoFilterModel: any = new Array();
  vendorFilterModel: any = new Array();
  requestStatusFilterModel: any = new Array();
  slaTimingFilterModel: any = new Array();
  requestIdFilterModel: any = new Array();
  ageFilterModel: any = new Array();
  createdDateFilterModel: any = new Array();

  snoFilterData: any = [];
  createdTypeFilterData: any = [];
  TicketIdFilterData: any = [];
  usernameFilterData: any = [];
  nameFilterData: any[];
  vehNoFilterData: any[];
  requestStatusFilterData: any[];
  requestIdFilterData: any[];
  slaTimingFilterData: any[];
  ageFilterData: any[];
  createdDateFilterData: any[];

  dateDisabled: Boolean = true;
  dropdownSettings = {};

  slaNextWorkingDay: any;
  receivedVendor: any;
  carListTempData: any;
  vendorListTempData: any;
  tempData: any;
  currentURL: any;
  currentIndex = 0;
  downloadRecord: any[] = [];
  downloadcarReqlist: any[] = [];
  clickEvent: boolean = false;
  constructor(
    public awserviceProvider: AwsService,
    private formBuilder: FormBuilder,
    private userDetailservice: UserDetailsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private capSmsMail: CapSMSMailService,
    private dateUtil: DateutilService,
    private pushNotificationService: AwsAppServiceProvider,
    private datepipe: DatePipe,
    private router: Router
  ) {
    console.log("CAR_MAINTANCE_CONSTRUCTOR");
    this.that = this;
    // this.noOfItems, this.pagenationNextToken
    // this.getAllData();
    // alert('page refersh')
    this.getAllDataCarMaintance();
    // spinnerService.show();
    this.selectDateMinTime();
    //this.sendPushNotification();
    // this.changePage(1);
  }
  // async getAllDataCarMaintance(nextToken: string = null) {
  //   console.log("Fetching car maintenance data...");

  //   const limit = 100;  // Page size (limit)
  //   this.carReqlist = [];  // Initialize the carReqlist
  //   this.tempData = [];  // Initialize tempData to accumulate data
  //   this.spinnerService.show();  // Show spinner

  //   try {
  //     // Continue fetching data until nextToken is null
  //     while (nextToken !== null) {
  //       const data = await this.awserviceProvider.getCarMaintenanceNextTokenPage(nextToken, limit);
  //       console.log("Page data:", data);

  //       // Append new items to tempData
  //       this.tempData = [...this.tempData, ...data.items];  // Append fetched items to tempData
  //       console.log('Temp data after appending:', this.tempData);

  //       // Update nextToken for the next iteration
  //       nextToken = data.nextToken;
  //       console.log("Next Token:", nextToken);
  //     }

  //     console.log("All data fetched:", this.tempData);

  //     // Perform additional processing after fetching all data
  //     this.getCreaterUser();
  //     this.getCardetails();

  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     this.spinnerService.hide();  // Hide spinner
  //   }
  // }

  async getAllDataCarMaintance() {
    console.log("Fetching car maintenance data...");
    // alert('carRequest' + this.carReqlist.length)
    const limit = 100;  // Set the limit for records per request
    //let offset: number = 0;
    let nextToken: string = null;  // Start with null for the first page
    this.tempData = [];  // Initialize tempData to store fetched data
    this.spinnerService.show();  // Show spinner while loading data

    try {
      // Loop until nextToken becomes null (no more pages)
      //do {
      // Fetch data from API, starting with null nextToken for the first page
      const data = await this.awserviceProvider.getCarMaintenanceNextTokenPage(nextToken, limit);
      console.log("Fetched Page Data:", data);

      // Append the fetched records to tempData
      this.tempData = [...this.tempData, ...data];
      console.log(`Total records fetched so far: ${this.tempData.length}`);

      // Update nextToken for the next iteration (will be null if no more pages)
      nextToken = data.nextToken;
      // if (data && data.length === limit) {
      //   offset += limit;
      // }
      // else {
      //   offset = 0;
      // }
      //} while (nextToken !== null && nextToken != undefined);  // Continue as long as there's a nextToken

      console.log("All records fetched:", this.tempData);

      // After fetching all records, process the data
      this.getCreaterUser();
      this.getCardetails();

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.spinnerService.hide();  // Hide the spinner after the process
    }

    if (this.pagenationNextToken == null) {
      this.isnextBtn = true;
    }
  }



  // async getAllDataCarMaintance(nextToken: string = null) {
  //   console.log("Fetching car maintenance data...");

  //   const limit = 100;  // You can set your page size (limit) here
  //   let hasNextPage = true;

  //   // Store all the records fetched
  //   this.carReqlist = [];  // Initialize the carReqlist
  //   this.tempData = [];  // Initialize tempData to accumulate data

  //   this.spinnerService.show();

  //   // Fetch data recursively until nextToken is null
  //   while (hasNextPage) {
  //     await this.awserviceProvider.getCarMaintenanceNextTokenPage(nextToken, limit)
  //       .then((data) => {
  //         console.log("Page data:", data);
  //         //  alert('data_start')
  //         // Append the new items to the list this.carReqlist
  //         this.tempData = [...this.carReqlist, ...data.items];
  //         // = this.carReqlist //data["items"];
  //         // Get the next token for the next page
  //         nextToken = data.nextToken;
  //         console.log("Next Token:", nextToken);

  //         console.log('Temp_data', this.tempData)

  //         // If nextToken is null, it means we've reached the last page
  //         if (!nextToken) {
  //           alert(nextToken)
  //           hasNextPage = false;

  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching data:", error);
  //         hasNextPage = false;  // Stop the loop if there's an error
  //       });
  //   }
  //   // this.getFilteredRecords();
  //   this.getCreaterUser();
  //   this.getCardetails();
  //   this.spinnerService.hide();

  //   console.log("All data fetched:", this.carReqlist);

  // }

  dropDownSetup() {
    this.dropdownSettings = {
      sno: {
        singleSelection: false,
        idField: "sno",
        enableCheckAll: true,
        itemsShowLimit: 2,
        allowSearchFilter: true,
        searchPlaceholderText: "Search S.No.",
      },
      /*  createType: {
        singleSelection: false,
        idField: "createType",
        enableCheckAll: true,
        itemsShowLimit: 2,
        allowSearchFilter: true,
        searchPlaceholderText: "Search createType.",
      },
      ticketId: {
        singleSelection: false,
        idField: "ticketId",
        enableCheckAll: true,
        itemsShowLimit: 2,
        allowSearchFilter: true,
        searchPlaceholderText: "Search ticket id.",
      }, */
      username: {
        singleSelection: false,
        idField: "username",
        enableCheckAll: true,
        itemsShowLimit: 1,
        allowSearchFilter: true,
        searchPlaceholderText: "Search RN No.",
      },
      name: {
        singleSelection: false,
        idField: "name",
        enableCheckAll: true,
        itemsShowLimit: 1,
        allowSearchFilter: true,
        closeDropDownOnSelection: true,
        searchPlaceholderText: "Search Name",
      },
      veh_reg_no: {
        singleSelection: false,
        idField: "veh_reg_no",
        enableCheckAll: true,
        itemsShowLimit: 1,
        allowSearchFilter: true,
        closeDropDownOnSelection: true,
        searchPlaceholderText: "Search Car No.",
      },
      vendor_name: {
        singleSelection: false,
        idField: "vendor_name",
        enableCheckAll: true,
        itemsShowLimit: 1,
        allowSearchFilter: true,
        closeDropDownOnSelection: true,
        searchPlaceholderText: "search vendor name.",
      },
      request_id: {
        singleSelection: false,
        idField: "request_id",
        enableCheckAll: true,
        itemsShowLimit: 1,
        allowSearchFilter: true,
        searchPlaceholderText: "Search Request ID",
      },
      request_status: {
        singleSelection: false,
        idField: "request_status",
        enableCheckAll: true,
        itemsShowLimit: 1,
        allowSearchFilter: true,
        searchPlaceholderText: "Search Request Status",
      },
      sla_timing: {
        singleSelection: false,
        idField: "sla_timing",
        enableCheckAll: true,
        itemsShowLimit: 1,
        allowSearchFilter: true,
        searchPlaceholderText: "Search SLA",
      },
      age: {
        singleSelection: false,
        idField: "age",
        enableCheckAll: true,
        itemsShowLimit: 1,
        allowSearchFilter: true,
        searchPlaceholderText: "Search age",
      },
      created_date: {
        singleSelection: false,
        idField: "created_date",
        enableCheckAll: true,
        itemsShowLimit: 1,
        allowSearchFilter: true,
        searchPlaceholderText: "Search Date",
      },
    };
  }

  // GET DATA
  async getAllData() {
    //itemCount, nextToken
    // this.carReqlist = [];
    //itemCount, nextToken
    console.log("Current_page", this.current_page);
    this.pagenationNextToken = "";
    console.log("Car data getAllData");
    this.spinnerService.show();
    await this.awserviceProvider.getCarMaintenanceListAll().then((data) => {
      console.log("GET_ALLDATA", data);
      this.pagenationNextToken = data["nextToken"];
      this.tempData = data["items"];
      this.downloadRecord = data["items"];


      // this.getFilteredRecords();
      //this.getCardetails();
      //this.getuserInfo("d79c9680-5a2a-4f76-bca7-c495b3c3adb1");
    });

    if (this.pagenationNextToken == null) {
      this.isnextBtn = true;
    }
  }

  getFilteredRecords(): void {

    const today = new Date();
    const sixMonthsAgo = new Date(today);
    sixMonthsAgo.setMonth(today.getMonth() - 6);

    // this.tempData = this.tempData.filter(record => {
    //   const recordDate = new Date(record.created_date);
    //   return recordDate >= sixMonthsAgo && recordDate <= today;
    // });
    this.tempData = this.tempData
      .filter(record => {
        const recordDate = new Date(record.created_date);
        return recordDate >= sixMonthsAgo && recordDate <= today;
      })
      .sort((a, b) => {
        const dateA = new Date(a.created_date).getTime();
        const dateB = new Date(b.created_date).getTime();

        return dateB - dateA;  // Sort in descending order (latest first)
        // return dateA - dateB;  // Sort in ascending order (oldest first)
      })
    // const today = new Date();
    // const sixMonthsAgo = new Date(today);
    //  sixMonthsAgo.setMonth(today.getMonth() - 6);

    // // this.tempData = this.tempData.filter(record => {
    // //   const recordDate = new Date(record.created_date);
    // //   return recordDate >= sixMonthsAgo && recordDate <= today;
    // // });
    // this.tempData = this.tempData
    // .filter(record => {
    //   const recordDate = new Date(record.created_date);
    //   return recordDate >= sixMonthsAgo && recordDate <= today;
    // })
    // .sort((a, b) => {
    //   const dateA = new Date(a.created_date).getTime();
    //   const dateB = new Date(b.created_date).getTime();

    //   return dateB - dateA;  // Sort in descending order (latest first)
    //   // return dateA - dateB;  // Sort in ascending order (oldest first)
    // });


    console.log(this.tempData);
    this.getCreaterUser();
    this.getCardetails();
  }


  sorting() { }
  async getCardetails() {
    await this.awserviceProvider.getCarListAll().then((car) => {
      //console.log(":::CAR:", car);
      this.carListTempData = car.items;
      if (this.carListTempData.length > 0) {
        // this.getVendorDetails();
        this.addVendor();
      }
    });

    // do something with response
  }

  async getVendorDetails() {
    await this.awserviceProvider.getActiveVendorlist().then((vendor) => {
      console.log("VENDOR");
      this.vendorListTempData = vendor;
      if (this.vendorListTempData.length > 0) {
        this.addVendor();
      }
    });
  }
  // async addvendorExportData() {
  //   let count = 0;
  //   if (!this.tempData) {

  //     return;
  //   }
  //   let tempDatalength = this.tempData.length;
  //   console.log("this.tempData.length;", this.tempData.length);
  //   for (let index = 0; index < this.tempData.length; index++) {
  //     const tempElement = this.tempData[index];
  //     console.log("tempElement", tempElement);
  //     count++;
  //     for (let j = 0; j < this.carListTempData.length; j++) {
  //       const carElement = this.carListTempData[j];
  //       console.log("carElement", carElement);

  //       if (tempElement.car_id == carElement.id) {
  //         console.log("response", carElement.agency_name);
  //         // this.tempData[index]["vendor_agency_name"] = carElement.agency_name;
  //         //
  //         // debugger;
  //         const getVendor = this.constructvendorName(carElement.agency_name);
  //         this.tempData[index]["vendorName"] = getVendor;
  //         // debugger;
  //       }
  //     }
  //   }

  //   console.log("TEMP_DATA", this.tempData);
  //   await this.constructData(this.tempData, true)

  // }

  addVendor() {
    let count = 0;
    let tempDatalength = this.tempData.length;
    console.log("this.tempData.length;", this.tempData.length);
    for (let index = 0; index < this.tempData.length; index++) {
      const tempElement = this.tempData[index];
      //console.log("tempElement", tempElement);
      count++;
      for (let j = 0; j < this.carListTempData.length; j++) {
        const carElement = this.carListTempData[j];
        //console.log("carElement", carElement);
        //console.trace(carElement)
        if (tempElement.car_id == carElement.id) {
          //console.log("response", carElement.agency_name);

          // this.tempData[index]["vendor_agency_name"] = carElement.agency_name;
          //
          // debugger;
          // const getVendor = this.constructvendorName(carElement.agency_name);
          this.tempData[index]["vendorName"] = carElement.agency.name;
          // debugger;
        }
      }
    }

    console.log("TEMP_DATA", this.tempData);
    this.constructData(this.tempData);
  }

  constructvendorName(agencyId) {
    let vendor;
    for (let index = 0; index < this.vendorListTempData.length; index++) {
      const vendorElement = this.vendorListTempData[index];
      console.log("vendorElement", vendorElement);
      if (vendorElement.id == agencyId) {
        console.log("VENDOR_response", vendorElement.name);
        //  debugger;
        /// this.tempData["vendorName"] = vendorElement.name;
        vendor = vendorElement.name;
        // this.constructData(this.tempData);
        //  debugger;
      }
    }

    return vendor;
  }

  async getCreaterUser() {
    for (let index = 0; index < this.tempData.length; index++) {
      // console.log("GET_RNC_ID", this.tempData[index].rncuser_id);
      //this.tempData[index].rncuser_id
    }
  }

  getuserInfo(id) {
    this.awserviceProvider.findUserById(id).then((user) => {
      console.log("VENDOR_user", user);
      // this.tempData["rncuser_Name"] = user[0].name;
      // this.vendorListTempData = vendor;
      // if (this.vendorListTempData.length > 0) {
      //   this.addVendor();
      // }
    });
  }

  // async constructData(data, isExport = false) {
  //   console.log("construct_data", data);

  //   let oplist = [];

  //   for (let i in data) {
  //     let rsdata = data[i];

  //     // Setting values for fields
  //     data[i].vendor_name = data[i].vendorName;
  //     data[i].name = rsdata.user_display_name;
  //     data[i].odometer = data[i].odometer;
  //     data[i].veh_reg_no = rsdata.veh_reg_no || "-";
  //     data[i].request_statusSort = AppConstants.REQUEST_STATUS[data[i].request_status];
  //     data[i].request_statusColor = this.getStatusColor(data[i].request_status);

  //     // Calculate age and ageSort based on request status
  //     let createdDate = new Date(data[i].created_date);
  //     if (
  //       data[i].request_status === "CANCELLED" ||
  //       data[i].request_status === "REJECTED" ||
  //       data[i].request_status === "COMPLETED"
  //     ) {
  //       let lastCommentDate = new Date(data[i].comments[data[i].comments.length - 1].date);
  //       data[i].age = this.getRelativeTime(createdDate, lastCommentDate);
  //       data[i].ageSort = this.getDifferenceInSeconds(createdDate, lastCommentDate);
  //     } else {
  //       data[i].age = this.getRelativeTime(createdDate, new Date());
  //       data[i].ageSort = this.getDifferenceInSeconds(createdDate, new Date());
  //     }

  //     // Calculate SLA timing
  //     data[i].sla_timing = "-";
  //     data[i].sla_timing_color = "";
  //     if (data[i].request_status === "NEW_REQUEST") {
  //       let newReq = this.dateUtil.getNumberOfWorkingDays(new Date(), createdDate);
  //       if (newReq < -1) {
  //         data[i].sla_timing = (-newReq) + " working days is elapsed";
  //         data[i].sla_timing_color = AppConstants.StatusCssClass.ELAPSED;
  //         data[i].request_statusSort = newReq;
  //       } else {
  //         data[i].sla_timing = "1 working day is remaining";
  //       }
  //     } else if (data[i].request_status === "ACKNOWLEDGED" || data[i].request_status === "IN_PROGRESS") {
  //       if (data[i].sla_date) {
  //         let slaDate = new Date(data[i].sla_date);
  //         let ackInpro = this.dateUtil.getNumberOfWorkingDays(new Date(), slaDate);
  //         if (ackInpro > 0) {
  //           data[i].sla_timing = ackInpro + " working days is remaining";
  //         } else {
  //           data[i].sla_timing = (-ackInpro) + " working days is elapsed";
  //           data[i].sla_timing_color = AppConstants.StatusCssClass.ELAPSED;
  //           data[i].request_statusSort = ackInpro;
  //         }
  //       }
  //     }

  //     oplist.push(data[i]);
  //   }

  //   // Sort list based on request status and created date
  //   oplist.sort((a, b) => {
  //     if (a.request_statusSort < b.request_statusSort) return -1;
  //     if (a.request_statusSort > b.request_statusSort) return 1;

  //     let adate: any = new Date(a.created_date);
  //     let bdate: any = new Date(b.created_date);

  //     if (a.sla_timing === "-" && b.sla_timing === "-") {
  //       return bdate - adate;
  //     } else {
  //       return adate - bdate;
  //     }
  //   });

  //   // Assign the updated list
  //   this.carReqlist = [...this.carReqlist, ...this.addSno(oplist)];

  //   console.log("CONSTRUCT_DATA", oplist);

  //   this.constructDropDownData(this, oplist, true);
  // }

  // Helper function to calculate time difference in seconds
  getDifferenceInSeconds(startDate, endDate) {
    return Math.floor((endDate - startDate) / 1000);
  }

  // Helper function to get relative time
  getRelativeTime(startDate, endDate) {
    const seconds = this.getDifferenceInSeconds(startDate, endDate);
    const minute = 60, hour = 60 * minute, day = 24 * hour;

    if (seconds < minute) return `${seconds} seconds ago`;
    if (seconds < hour) return `${Math.floor(seconds / minute)} minutes ago`;
    if (seconds < day) return `${Math.floor(seconds / hour)} hours ago`;
    return `${Math.floor(seconds / day)} days ago`;
  }

  // Helper function to determine status color
  getStatusColor(status) {
    if (status === "NEW_REQUEST") return AppConstants.StatusColor.ORANGE;
    if (status === "ACKNOWLEDGED" || status === "IN_PROGRESS") return AppConstants.StatusColor.GREEN;
    return "";
  }

  // // Add serial number to the list
  // addSno(list) {
  //   return list.map((item, index) => ({ ...item, sno: index + 1 }));
  // }


  async constructData(data, isExport?: any) {

    this.carReqlist = [];
    console.log("construct_data", data);

    var oplist = [];
    for (var i in data) {
      var rsdata = data[i];
      // data[i].sno=+i+1;

      // var val = await this.userDetailservice.getDetails(data[i].username);
      // console.log("construct data val", val);
      // data[i].name = val.name;
      // var name;
      // if (rsdata.user_display_name == undefined) {
      //   var val = await this.userDetailservice.getDetails(rsdata.username);
      //   name = val.name;
      // } else {
      //   name = rsdata.user_display_name;
      // }
      /*  data[i].created_type = data[i].created_type;
      data[i].ticket_id = data[i].ticket_id; */
      data[i].vendor_name = data[i].vendorName;
      data[i].name = rsdata.user_display_name;
      data[i].odometer = data[i].odometer;

      if (
        data[i].request_status == "CANCELLED" ||
        data[i].request_status == "REJECTED" ||
        data[i].request_status == "COMPLETED"
      ) {
        var f = moment(data[i].created_date);
        var s = moment(data[i].comments[data[i].comments.length - 1].date);
        data[i].age = f.from(s, true);
        data[i].ageSort = f.diff(s, "seconds");
      } else {
        data[i].age = moment(data[i].created_date).fromNow(false);
        data[i].ageSort = moment().diff(
          moment(data[i].created_date),
          "seconds"
        );
      }
      data[i].veh_reg_no =
        rsdata.veh_reg_no == undefined ? "-" : rsdata.veh_reg_no;
      data[i].request_statusSort =
        AppConstants.REQUEST_STATUS[data[i].request_status];
      data[i].request_statusColor =
        data[i].request_status == "NEW_REQUEST"
          ? AppConstants.StatusColor.ORANGE
          : data[i].request_status == "ACKNOWLEDGED" ||
            data[i].request_status == "IN_PROGRESS"
            ? AppConstants.StatusColor.GREEN
            : "";

      data[i].sla_timing = "-";
      data[i].sla_timing_color = "";

      if (data[i].request_status == "NEW_REQUEST") {
        var newReq = this.dateUtil.getNumberOfWorkingDays(
          new Date(),
          new Date(data[i].created_date)
        );
        if (newReq < -1) {
          data[i].sla_timing = newReq * -1 + " working days is elapsed";
          data[i].sla_timing_color = AppConstants.StatusCssClass.ELAPSED;
          data[i].request_statusSort = newReq;
        } else {
          data[i].sla_timing = "1 working day is remaining";
        }
      } else if (
        data[i].request_status == "ACKNOWLEDGED" ||
        data[i].request_status == "IN_PROGRESS"
      ) {
        console.log("::SLA DATE:: BE", data[i]);
        if (data[i].sla_date != null) {
          var ackInpro = this.dateUtil.getNumberOfWorkingDays(
            new Date(),
            new Date(data[i].sla_date)
          );
          console.log("ackInpro", ackInpro);
          if (ackInpro > 0)
            data[i].sla_timing = ackInpro + " working days is remaining";
          if (ackInpro < 0) {
            data[i].sla_timing = ackInpro * -1 + " working days is elapsed";
            data[i].sla_timing_color = AppConstants.StatusCssClass.ELAPSED;
            data[i].request_statusSort = ackInpro;
          }
        }
      }
      oplist.push(data[i]);
    }

    oplist = oplist.sort((a, b) => {
      if (a.request_statusSort < b.request_statusSort) {
        return -1;
      } else if (a.request_statusSort > b.request_statusSort) {
        return 1;
      } else if (a.request_statusSort == b.request_statusSort) {
        var adate = new Date(a.created_date);
        var bdate = new Date(b.created_date);
        if (a.sla_timing == "-" && b.sla_timing == "-") {
          if (adate.getTime() > bdate.getTime()) {
            return -1;
          } else if (adate.getTime() < bdate.getTime()) {
            return 1;
          }
        } else {
          if (adate.getTime() > bdate.getTime()) {
            return 1;
          } else if (adate.getTime() < bdate.getTime()) {
            return -1;
          }
        }

        return 0;
      }

      return 0;
    });
    //  oplist = this.addSno(oplist);
    // if(isExport) {
    //   this.downloadcarReqlist = Object.assign([...this.downloadcarReqlist,...oplist]);
    //   this.downloadcarReqlist = this.addSno(this.downloadcarReqlist);
    //   return true;
    // }
    this.carReqlist = this.addSno(this.carReqlist)
    this.masterCarReqlist = [...this.carReqlist];
    this.constructDropDownData(this, this.masterCarReqlist, true);
    this.carReqlist = [...this.carReqlist, ...oplist];

    this.carReqlist = this.addSno(this.carReqlist);



    // this.carReqlist.pushoplist;
    console.log("CONSTRUCT_DATA", oplist);

    // this.clientSideStoreRecord(oplist);
    this.constructDropDownData(this, oplist, true);
  }

  private addSno(list: any[]): any[] {
    var ls: any[] = [];
    for (var rs in list) {
      var rsdata = list[rs];
      ls[rs] = rsdata;
      ls[rs].sno = +rs + 1;
    }
    return ls;
  }

  clientSideStoreRecord(oplist) {
    for (let index = 0; index < oplist.length; index++) {
      const element = oplist[index];

      this.clientSideStore.push(element);
      console.log("ClientSideStore", this.clientSideStore);
    }

    // Check if the array is empty
    // if (this.clientSideStore.length === 0) {
    //   console.log("The array is empty.");
    // } else if (this.clientSideStore.length > 1) {
    //   console.log(
    //     "The array has more than one element. This message will be printed only once."
    //   );
    //   this.changePage(1);
    // }

    // // if (this.clientSideStore.length != 0) {
    // //   this.changePage(1);
    // // } else {
    // //   return;
    // // }
  }

  openStatus(carMainRequest) {
    this.carMainModalBox = carMainRequest.comments;
  }

  openFeedBackStatus(value) {
    console.log("feedback", value.feedback);
    console.log("status", value.satisfaction);
    this.carFeedBackBox = [];
    this.carFeedBackBox.push(value);
    console.log("this.carFeedBackBox", this.carFeedBackBox);
  }

  filterSearch(th, items, filter) {
    console.log("FILTER_SEARCH", items);

    // Helper function to safely check if a filter array has items
    const isValidFilter = (filterArray) => Array.isArray(filterArray) && filterArray.length > 0;

    let result = items.filter((val) => {
      // Check if all filter properties are empty
      if (
        !isValidFilter(filter.sno) &&
        !isValidFilter(filter.username) &&
        !isValidFilter(filter.name) &&
        !isValidFilter(filter.veh_reg_no) &&
        !isValidFilter(filter.vendor_name) &&
        !isValidFilter(filter.request_id) &&
        !isValidFilter(filter.request_status) &&
        !isValidFilter(filter.sla_timing) &&
        !isValidFilter(filter.age) &&
        !isValidFilter(filter.created_date)
      ) {
        return true; // No filters applied, return all items
      } else {
        // Apply the filters only if the corresponding filter arrays have values
        return (
          (!isValidFilter(filter.sno) || filter.sno.indexOf("" + val.sno) >= 0) &&
          (!isValidFilter(filter.username) || filter.username.indexOf(val.username) >= 0) &&
          (!isValidFilter(filter.name) || filter.name.indexOf(val.name) >= 0) &&
          (!isValidFilter(filter.veh_reg_no) || filter.veh_reg_no.indexOf(val.veh_reg_no) >= 0) &&
          (!isValidFilter(filter.vendor_name) || filter.vendor_name.indexOf(val.vendor_name) >= 0) &&
          (!isValidFilter(filter.request_id) || filter.request_id.indexOf(val.request_id) >= 0) &&
          (!isValidFilter(filter.age) || filter.age.indexOf(val.age) >= 0) &&
          (!isValidFilter(filter.request_status) || filter.request_status.indexOf(val.request_status) >= 0) &&
          (!isValidFilter(filter.sla_timing) || filter.sla_timing.indexOf(val.sla_timing) >= 0) &&
          (!isValidFilter(filter.created_date) ||
            filter.created_date.indexOf(formatDate(val.created_date, "MMM dd, yyyy", "en")) >= 0)
        );
      }
    });

    // Construct dropdown data with the filtered results
    //th.constructDropDownData(th, result, false);

    return result;
  }


  // filterSearch(th, items, filter) {
  //   console.log("FILTER_SEARCH", items);
  //   let result = items.filter((val) => {
  //     if (
  //       filter.sno.length == 0 &&
  //       filter.username.length == 0 &&
  //       filter.name.length == 0 &&
  //       filter.veh_reg_no.length == 0 &&
  //       filter.vendor.length == 0 &&
  //       filter.request_id.length == 0 &&
  //       filter.request_status.length == 0 &&
  //       filter.sla_timing.length == 0 &&
  //       filter.age.length == 0 &&
  //       filter.created_date.length == 0
  //     ) {
  //       return true;
  //     } else {
  //       // if(filter.sno.indexOf(""+val.sno)>=0 && filter.username.indexOf(val.username)>=0 && filter.name.indexOf(val.name)>=0 && concernFound.length>0 && filter.request_id.indexOf(val.request_id)>=0 && filter.request_status.indexOf(val.request_status)>=0 && filter.created_date.indexOf(formatDate(val.created_date,'MMM dd, yyyy','en'))>=0)
  //       return (
  //         (filter.sno.length > 0
  //           ? filter.sno.indexOf("" + val.sno) >= 0
  //           : true) &&
  //         (filter.username.length > 0
  //           ? filter.username.indexOf(val.username) >= 0
  //           : true) &&
  //         (filter.name.length > 0
  //           ? filter.name.indexOf(val.name) >= 0
  //           : true) &&
  //         (filter.veh_reg_no.length > 0
  //           ? filter.veh_reg_no.indexOf(val.veh_reg_no) >= 0
  //           : true) &&
  //         (filter.vendor_name.length > 0
  //           ? filter.vendor_name.indexOf(val.vendor_name) >= 0
  //           : true) &&
  //         (filter.request_id.length > 0
  //           ? filter.request_id.indexOf(val.request_id) >= 0
  //           : true) &&
  //         (filter.age.length > 0 ? filter.age.indexOf(val.age) >= 0 : true) &&
  //         (filter.request_status.length > 0
  //           ? filter.request_status.indexOf(val.request_status) >= 0
  //           : true) &&
  //         (filter.sla_timing.length > 0
  //           ? filter.sla_timing.indexOf(val.sla_timing) >= 0
  //           : true) &&
  //         (filter.created_date.length > 0
  //           ? filter.created_date.indexOf(
  //             formatDate(val.created_date, "MMM dd, yyyy", "en")
  //           ) >= 0
  //           : true)
  //       );
  //     }
  //   });

  //   th.constructDropDownData(th, result, false);

  //   return result;
  // }

  checkFilterValue(filter, val) {
    return (
      (filter.sno.length > 0
        ? filter.sno.indexOf("" + val.sno) >= 0
        : true) &&
      (filter.username.length > 0
        ? filter.username.indexOf(val.username) >= 0
        : true) &&
      (filter.name && filter.name.length > 0
        ? filter.name.indexOf(val.name) >= 0
        : true) &&
      (filter.veh_reg_no.length > 0
        ? filter.veh_reg_no.indexOf(val.veh_reg_no) >= 0
        : true) &&
      (filter.vendor_name && filter.vendor_name.length > 0
        ? filter.vendor_name.indexOf(val.vendor_name) >= 0
        : true) &&
      (filter.request_id.length > 0
        ? filter.request_id.indexOf(val.request_id) >= 0
        : true) &&
      (filter.age.length > 0 ? filter.age.indexOf(val.age) >= 0 : true) &&
      (filter.request_status.length > 0
        ? filter.request_status.indexOf(val.request_status) >= 0
        : true) &&
      (filter.sla_timing.length > 0
        ? filter.sla_timing.indexOf(val.sla_timing) >= 0
        : true) &&
      (filter.created_date.length > 0
        ? filter.created_date.indexOf(
          formatDate(val.created_date, "MMM dd, yyyy", "en")
        ) >= 0
        : true)
    );
  }
  constructDropDownData(th, items, isData) {
    console.log("constructDropDownData", items);

    const snoData = [];
    const usernameData = [];
    const nameData = [];
    const vehNoData = [];
    const vendorData = [];
    const requestIdData = [];
    const requestStatusData = [];
    const slaTimingData = [];
    const ageData = [];
    const createdDateData = [];

    // Helper function to check for null, undefined and uniqueness
    const pushIfValid = (arr, value) => {
      if (value !== null && value !== undefined && arr.indexOf(value) === -1) {
        arr.push(value);
      }
    };

    for (const item of items) {
      pushIfValid(snoData, "" + item.sno);
      pushIfValid(usernameData, item.username);
      pushIfValid(nameData, item.name);
      pushIfValid(vehNoData, item.veh_reg_no);
      pushIfValid(vendorData, item.vendor_name);
      pushIfValid(ageData, item.age);
      pushIfValid(requestIdData, item.request_id);
      pushIfValid(requestStatusData, item.request_status);
      pushIfValid(slaTimingData, item.sla_timing);

      // Format created date before pushing it
      const formattedDate = item.created_date
        ? formatDate(item.created_date, "MMM dd, yyyy", "en")
        : null;
      pushIfValid(createdDateData, formattedDate);
    }

    console.log("constructDropDownData - Vendor Data:", vendorData);

    const updateDropdownData = () => {
      th.snoFilterData = snoData;
      th.usernameFilterData = usernameData;
      th.nameFilterData = nameData;
      th.vehNoFilterData = vehNoData;
      th.vendorFilterData = vendorData;
      th.requestIdFilterData = requestIdData;
      th.ageFilterData = ageData;
      th.requestStatusFilterData = requestStatusData;
      th.slaTimingFilterData = slaTimingData;
      th.createdDateFilterData = createdDateData;
    };
    if (!isData) {
      // Skip updates when filtering to avoid shrinking options
      return;
    }
    updateDropdownData();
    // if (isData) {
    //   // Directly update filter data when `isData` is true
    //   updateDropdownData();
    // } else {
    //   // Delay the update when `isData` is false
    //   setTimeout(() => {
    //     updateDropdownData();
    //   }, 15000);
    // }

    console.log("Updated Vendor Filter Data:", th.vendorFilterData);
  }

  // constructDropDownData(th, items, isData) {
  //   console.log("constructDropDownData", items);
  //   //  console.log("constructDropDownData",th.usernameFilterData);

  //   var snoData = [];
  //   var createdTypeData = [];
  //   var ticketIdData = [];
  //   var usernameData = [];
  //   var nameData = [];
  //   var vehNoData = [];
  //   var vendorData = [];
  //   var requestIdData = [];
  //   var requestStatusData = [];
  //   var slaTimingData = [];
  //   var ageData = [];
  //   var createdDateData = [];

  //   for (var item of items) {
  //     if (snoData.indexOf(item.sno) == -1) snoData.push("" + item.sno);
  //     /*  if (createdTypeData.indexOf(item.created_type) == -1)
  //       createdTypeData.push("" + item.created_type);
  //     if (ticketIdData.indexOf(item.ticket_id) == -1)
  //       ticketIdData.push("" + item.ticket_id); */
  //     if (usernameData.indexOf(item.username) == -1)
  //       usernameData.push(item.username);
  //     if (nameData.indexOf(item.name) == -1) nameData.push(item.name);
  //     if (vehNoData.indexOf(item.veh_reg_no) == -1)
  //       vehNoData.push(item.veh_reg_no);
  //     if (vendorData.indexOf(item.vendor_name) == -1)
  //       vendorData.push(item.vendor_name);
  //     if (ageData.indexOf(item.age) == -1) ageData.push(item.age);
  //     if (requestIdData.indexOf(item.request_id) == -1)
  //       requestIdData.push(item.request_id);
  //     if (requestStatusData.indexOf(item.request_status) == -1)
  //       requestStatusData.push(item.request_status);
  //     if (slaTimingData.indexOf(item.sla_timing) == -1)
  //       slaTimingData.push(item.sla_timing);
  //     if (
  //       createdDateData.indexOf(
  //         formatDate(item.created_date, "MMM dd, yyyy", "en")
  //       ) == -1
  //     )
  //       createdDateData.push(
  //         formatDate(item.created_date, "MMM dd, yyyy", "en")
  //       );
  //   }

  //   console.log("constructDropDownData-", vendorData);
  //   if (isData) {
  //     // th.snoFilterData = snoData;
  //     // /*   th.createTypeFilterData = createdTypeData;
  //     // th.TicketIdFilterData = ticketIdData; */
  //     // th.usernameFilterData = usernameData;
  //     // th.nameFilterData = nameData;
  //     // th.vehNoFilterData = vehNoData;
  //     // th.vendorFilterData = vendorData;
  //     // th.requestIdFilterData = requestIdData;
  //     // th.requestStatusFilterData = requestStatusData;
  //     // th.slaTimingFilterData = slaTimingData;
  //     // th.ageFilterData = ageData;
  //     // th.createdDateFilterData = createdDateData;

  //     th.snoFilterData = snoData;
  //     /*  th.createTypeFilterData = createdTypeData;
  //     th.TicketIdFilterData = ticketIdData; */
  //     th.usernameFilterData = usernameData;
  //     th.nameFilterData = nameData;
  //     th.vehNoFilterData = vehNoData;
  //     th.vendorFilterData = vendorData;
  //     th.requestIdFilterData = requestIdData;
  //     th.ageFilterData = ageData;
  //     th.requestStatusFilterData = requestStatusData;
  //     th.slaTimingFilterData = slaTimingData;
  //     th.createdDateFilterData = createdDateData;

  //     console.log("constructDropDownData_VENDOR-", th.vendorFilterData);
  //   } else {
  //     setTimeout(() => {
  //       /*   th.snoFilterModel=snoData
  //      th.usernameFilterModel=usernameData;
  //       th.nameFilterModel=nameData;
  //       th.concenTypeFilterModel=concenTypeData.filter((item,index) => concenTypeData.indexOf(item) === index)
  //       th.requestIdFilterModel=requestIdData
  //       th.requestStatusFilterModel=requestStatusData
  //       th.createdDateFilterModel=createdDateData */

  //       th.snoFilterData = snoData;
  //       /*  th.createTypeFilterData = createdTypeData;
  //       th.TicketIdFilterData = ticketIdData; */
  //       th.usernameFilterData = usernameData;
  //       th.nameFilterData = nameData;
  //       th.vehNoFilterData = vehNoData;
  //       th.vendorFilterData = vendorData;
  //       th.requestIdFilterData = requestIdData;
  //       th.ageFilterData = ageData;
  //       th.requestStatusFilterData = requestStatusData;
  //       th.slaTimingFilterData = slaTimingData;
  //       th.createdDateFilterData = createdDateData;
  //     }, 15000);
  //   }
  // }

  formInitilization() {
    this.carRequestFm = this.formBuilder.group({
      id: [""],
      comments_des: ["", Validators.required],
      comments_status: ["", [Validators.required, Validators.min(1)]],
      sl_date: [{ value: "", disabled: true }],
    });
  }

  get f() {
    return this.carRequestFm.controls;
  }

  //  EDIT DATA
  editData(carMainReq) {
    console.log("::::EDIT DATA ::", carMainReq);

    this.userCarDetails(carMainReq.car_id);
    this.singleCarData(carMainReq.id);
    this.editDataView = carMainReq;
    console.log("editData", carMainReq);
    this.userInfo = [];
    this.displayValue = 1;
    this.formInitilization();
    this.rowID = carMainReq.id;
    this.comments = carMainReq.comments;
    this.editDataView.comments = this.comments;
    this.editDataView.comments
    this.userInfo = [carMainReq];

    this.slaNextWorkingDay = "";

    // this.carRequestFm.get("sl_date").disable();

    // const selectedCountry = this.status.find(
    //   (item) => item.name === carMainReq.request_status
    // );
    // console.log("selectedCountry", selectedCountry);

    // this.carRequestFm.patchValue({
    //   comments_status: selectedCountry.name,
    //   sl_date: this.Setdata(carMainReq.sla_date),
    // });
    // this.carRequestFm.updateValueAndValidity();
    // console.log("formControl::", this.carRequestFm.getRawValue());
  }
  Setdata(param) {
    var todayDate = new Date(param);
    var month =
      (todayDate.getMonth() + 1 < 10 ? "0" : "") + (todayDate.getMonth() + 1);
    var date = (todayDate.getDate() < 10 ? "0" : "") + todayDate.getDate();
    var year = todayDate.getFullYear();

    var setDate = year + "-" + month + "-" + date;
    console.log("SET DATE", setDate);
    return setDate;
  }
  singleCarData(id) {
    // 1187 , 2556
    this.awserviceProvider
      .singleCarData(id)
      .then((result) => {
        console.log("xxxxxxxxx", result);
        this.statusComp = result[0].ex_data;
        console.log("this.statusComp", this.statusComp);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  userCarDetails(carid) {
    this.awserviceProvider
      .carIdFilter(carid)
      .then((result) => {
        console.log("car details", result);
        this.car_info = result;
      })
      .catch((err) => {
        console.log("err", err);
      });
  }
  refreshPage() {
    // alert(this.router.url)
    // this.router.navigate([this.router.url]);
    window.location.reload()
    // this.getAllDataCarMaintance();
  }
  // SAVE DATA
  async onSubmit() {
    this.submitted = true;
    if (this.carRequestFm.invalid) {
      return;
    }
    console.log("Add - car data", this.carRequestFm.value);
    var day = "";
    var sla = "0";
    let slaDateFormate = this.datepipe.transform(
      this.slaNextWorkingDay,
      "dd-MM-yyyy"
    );
    switch (this.carRequestFm.value.comments_status) {
      case "NEW_REQUEST":
        day = "INPRO";
        break;
      case "ACKNOWLEDGED":
        day = "INPRO";
        sla = `SLA for resolving this request will complete ${slaDateFormate}. DISCLAIMER: Timelines may vary subject to practical situation & condition of the issues.`;
        //AppConstants.REQUEST_SLA.CAR_REQUEST;
        break;
      case "IN_PROGRESS":
        day = "INPRO";
        sla = `SLA for resolving this request will complete ${slaDateFormate}. DISCLAIMER: Timelines may vary subject to practical situation & condition of the issues.`;
        break;
      case "REJECTED":
        day = "INPRO";
        break;
      case "BLOCKED":
        day = "INPRO";
        break;
      case "CANCELLED":
        day = "INPRO";
        break;
      case "COMPLETED":
        day = "INPRO";
        break;
    }
    var d = new Date();
    var test1 = {
      // date: this.carRequestFm.value.comments_date, // yyyy-mm-dd
      date: d.toISOString(),
      des: this.carRequestFm.value.comments_des,
      status: this.carRequestFm.value.comments_status,
      exdata: sla,
    };
    var carMainValue = {
      id: this.rowID,
      comments: this.comments.length === 0 ? [test1] : [...this.comments, test1],
      request_status: this.carRequestFm.value.comments_status,
      updated_date: d.toISOString(),
      ex_data: day,
      sla_date:
        this.slaNextWorkingDay == ""
          ? this.editDataView.sla_date
          : this.slaNextWorkingDay,
    };
    console.log("this.comments", carMainValue);

    const pushNotificationConfirmObject = {
      comments: this.carRequestFm.value.comments_des,
      status: this.carRequestFm.value.comments_status,
    };

    this.awserviceProvider
      .UpdateCarMaintenanceData(carMainValue)
      .then((result) => {
        this.rowID = "";
        this.comments = "";

        // if (result.created_type === "Admin") {
        //   this.findAdminUser(result.rncuser_id, pushNotificationConfirmObject);
        // }

        result['ccEmail'] = 'subburayan.ragavel-extern@renault.com'


        this.capSmsMail.sendMailandSMS(result, RequestType.CAR_REQUEST);

        this.constructPushNotification(result, pushNotificationConfirmObject);

        //this.noOfItems, this.pagenationNextToken
        // this.getAllDataCarMaintance();

        //old//
        // this.refreshPage();
        // this.displayValue = 0;

        //new//
        this.backbtn();
      })
      .catch((err) => {
        console.log("err", err);
      });

    // await this.router.navigateByUrl("/", { skipLocationChange: true });
    // return this.router.navigateByUrl(this.currentURL);
  }

  backbtn() {
    this.displayValue = 0;
    // this.snoFilterModel = new Array();
    // this.createdTypeFilterModel = new Array();
    // this.TicketIdFilterModel = new Array();
    // this.usernameFilterModel = new Array();
    // this.nameFilterModel = new Array();
    // this.vehNoFilterModel = new Array();
    // this.vendorFilterModel = new Array();
    // this.requestStatusFilterModel = new Array();
    // this.slaTimingFilterModel = new Array();
    // this.requestIdFilterModel = new Array();
    // this.ageFilterModel = new Array();
    // this.createdDateFilterModel= new Array();
    // // this.getAllData();
    this.getAllDataCarMaintance();
  }

  ngOnInit() {
    this.displayValue = 0;
    this.dropDownSetup();
    this.formInitilization();
    console.log("car data module init");
  }
  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   this.addvendorExportData();
    // }, 5000);

  }
  public sort(sortKey) {
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey) {
    if (this.sortKey == sortKey) {
      if (this.sortReverse) {
        return "fa fa-sort-desc";
      } else {
        return "fa fa-sort-asc";
      }
    } else {
      return "fa fa-sort";
    }
  }

  async exportToExcel() {

    let exportJsonReq: any;

    const dataSheetJson = this.excelDataFormation(this.carReqlist);
    const requestSheetJson = this.excelData1Acknowledge(this.carReqlist);

    const workBook = XLSX.utils.book_new(); // create a new blank book

    const workSheet = XLSX.utils.json_to_sheet(dataSheetJson, {
      header: [],
      skipHeader: false,
    });
    const workSheet1 = XLSX.utils.json_to_sheet(requestSheetJson, {
      header: [],
      skipHeader: false,
    });

    // ////console.log("EXCEL", exportJsonTemp);
    XLSX.utils.book_append_sheet(workBook, workSheet, "DATA"); // add the worksheet to the book
    XLSX.utils.book_append_sheet(workBook, workSheet1, "REPORT"); // add the worksheet to the book

    XLSX.writeFile(workBook, "Car Request-" + new Date().getTime() + ".xlsx");
  }

  excelDataFormation(list) {
    let dateFormat = require("dateformat");
    var dataSheet = [];
    var recordSheet = [];
    console.log("DOWNLOAD-LIST", list);

    for (var dSheet of list) {
      var dataRecord = {
        "S.No": dSheet.sno,
        "Request Date": dateFormat(dSheet.created_date, "yyyy-mm-dd"),
        "Request ID": dSheet.request_id,
        "RN Number": dSheet.username,
        "User Number": dSheet.name,
        "Car No.": dSheet.veh_reg_no.split(" - ")[0],
        odometer: dSheet.odometer,
        "Car Type": dSheet.veh_reg_no.split(" - ")[1],
        Vendor: dSheet.vendorName,
        "Request Status": dSheet.request_status,
        "Request Type": dSheet.user_request,
        "user Description": dSheet.user_text,
        SLA: dSheet.sla_timing,
        "Ticket Age": dSheet.age,
        "Feedback Status": dSheet.satisfaction == 0 ? "" : dSheet.satisfaction,
        "Feedback Description": dSheet.feedback == 0 ? "" : dSheet.feedback,
      };

      // for (var rSheet of dSheet.comments) {
      //   var requestSheet = {
      //     "Request ID": dSheet.request_id,
      //     "RN Number": dSheet.username,
      //     "User Number": dSheet.name,
      //     action: rSheet.status,
      //     comments: rSheet.des,
      //     date: rSheet.date,
      //   };
      // }

      dataSheet.push(dataRecord);
      // recordSheet.push(requestSheet);
    }
    console.log("::::", dataSheet, recordSheet);
    return dataSheet;
  }
  excelData1Acknowledge(list) {
    let dateFormat = require("dateformat");
    var otlist = [];
    console.log("DOWNLOAD-LIST", list);
    for (var l of list) {
      console.log("COMMENTS", l.comments);

      console.log("COMMENTS STATUS", l.comments[0].status);

      let res = {};
      Object.keys(l.comments).map((el, key) => {
        res[l.comments[el].status] = l.comments[el].des;
        console.log("res.l", l.comments[el].status);
        console.log("res.com", l.comments[el].des);

        if (l.comments[el].status == "NEW_REQUEST") {
        }
        var r = {
          "Request ID": l.request_id,
          "RN Number": l.username,
          "User Number": l.name,
          "Car No.": l.veh_reg_no.split(" - ")[0],
          Vendor: l.vendorName,
          Action: l.comments[el].status,
          Comments:
            l.comments[el].status == "NEW_REQUEST"
              ? l.user_text
              : l.comments[el].des,
          Date: dateFormat(l.comments[el].date, "yyyy-mm-dd HH:MM:ss"),
        };
        var keysUpper = Object.keys(r);
        var newObj = {};
        for (var i in keysUpper) {
          newObj[keysUpper[i].toUpperCase().replace(/[_-]/g, " ")] =
            r[keysUpper[i]];
        }
        console.log(JSON.stringify(newObj));
        console.log("::RRR:::", newObj);

        otlist.push(newObj);
      });
    }

    return otlist;
  }

  handler(e) {
    alert(e.target.value);
  }

  selectDateMinTime() {
    var todayDate = new Date();
    var month =
      (todayDate.getMonth() + 1 < 10 ? "0" : "") + (todayDate.getMonth() + 1);
    var day = (todayDate.getDate() < 10 ? "0" : "") + todayDate.getDate();
    var year = todayDate.getFullYear();
    this.minDate = year + "-" + month + "-" + day;
  }

  valuechange(paramDate: any) {
    console.log("SELECTED-DATE", paramDate);
    let date_1 = new Date(paramDate);
    let date_2 = new Date();

    const days = (date_1, date_2) => {
      let difference = date_1.getTime() - date_2.getTime();
      let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
      return TotalDays;
    };

    this.setDateToGo = days(date_1, date_2);
    // var day = new Date();
    // day = new Date(formatDate(day, "yyyy-MM-dd", "en"));
    // if (date.getDay() === 0 || date.getDay() === 6) {

    // }

    var day = new Date(paramDate).getUTCDay();
    if ([6, 0].includes(day)) {
      this.carRequestFm.controls.sl_date.setErrors({ invalidNumber: true });
    } else {
      this.carRequestFm.controls.sl_date.setErrors(null);
      this.slaNextWorkingDay = paramDate; //this.dateUtil.getNextWorkingDayFrom(paramDate);
    }

    // this.slaNextWorkingDay = this.dateUtil.getNextWorkingDayFrom(
    //   this.setDateToGo
    // );
    console.log(this.setDateToGo + " days to");
  }

  onStatusChange() {
    if (this.carRequestFm.value.comments_status == "ACKNOWLEDGED") {
      // this.slaNextWorkingDay = this.dateUtil.getNextWorkingDayFrom(
      //   this.setDateToGo
      // );
      this.carRequestFm.get("sl_date").enable();
    } else if (this.carRequestFm.value.comments_status == "IN_PROGRESS") {
      // this.slaNextWorkingDay = this.dateUtil.getNextWorkingDayFrom(
      //   this.setDateToGo
      // );

      this.carRequestFm.get("sl_date").enable();
    } else {
      this.carRequestFm.get("sl_date").disable();
    }
    {
    }
  }

  findAdminUser(userId, obj) {
    console.log("find__admin__user", userId);
    this.awserviceProvider
      .rnUserFilterById(userId.rncuser_id)
      .then((result) => {
        console.log("FIND__USER__id::", result);
        // this.getAdminInfo(result.user_name)
        userId["adminRN"] = result.user_name;
        this.adminConstructPushNotification(userId, obj);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  getAdminInfo(username) {
    this.pushNotificationService.listApplicationServices(username).then(
      (items) => {
        console.log("GET_FCM_Token", items);
      },
      (error) => {
        // Some task on failure
        console.log("APP-SERVICE-LIST-ERROR", error);
      }
    );
  }

  adminConstructPushNotification(param, bodyMsg) {
    console.log("::pushNotificationObject", param);
    console.log("::PARAP_ID", param.id);
    console.log("::PARAP_ID", param.username);
    // Notification Title
    // Notification Content
    // Notification URL
    // Notification Icon
    // Browser Icon
    // Notification image

    this.pushNotificationService.listApplicationServices(param.adminRN).then(
      (items) => {
        console.log("GET_FCM_USER", items);
        console.log("GET_FCM_TOKEN", items.fcm_token);
        var status = param.request_status.toUpperCase().replace(/[_-]/g, " ");
        var pushObj: pushNotification = {
          token: items.fcm_token,
          notification: {
            title: "RNConnect - Cap Assits ",
            body:
              `Car maintance - Your request id  ${param.request_id} ` +
              " status is " +
              status,
          },
          android: {
            notification: {
              click_action: "FCM_PLUGIN_ACTIVITY",
            },
          },
          apns: {
            headers: {
              "apns-priority": "5",
            },
            payload: {
              aps: {
                category: "NEW_MESSAGE_CATEGORY",
              },
            },
          },
          data: {
            icon: "ic_launcher",
            navigationTo: "ca-notification",
            content: bodyMsg.comments,
            did: param.car_id,
            cp_header: "car",
            request_id: param.request_id
          },
        };
        this.capSmsMail.pushNotificationFCM(pushObj);
      },
      (error) => {
        // Some task on failure
        console.log("APP-SERVICE-LIST-ERROR", error);
      }
    );
  }

  constructPushNotification(param, bodyMsg) {
    console.log("::pushNotificationObject", param);
    console.log("::PARAP_ID", param.id);
    console.log("::PARAP_ID", param.username);
    // Notification Title
    // Notification Content
    // Notification URL
    // Notification Icon
    // Browser Icon
    // Notification image

    this.pushNotificationService.listApplicationServices(param.username).then(
      (items) => {
        console.log("GET_FCM_USER", items);
        console.log("GET_FCM_TOKEN", items.fcm_token);
        var status = param.request_status.toUpperCase().replace(/[_-]/g, " ");
        var pushObj: pushNotification = {
          token: items.fcm_token,
          notification: {
            title: "RNConnect - Cap Assits ",
            body:
              `Car maintance - Your request id  ${param.request_id} ` +
              " status is " +
              status,
          },
          android: {
            notification: {
              click_action: "FCM_PLUGIN_ACTIVITY",
            },
          },
          apns: {
            headers: {
              "apns-priority": "5",
            },
            payload: {
              aps: {
                category: "NEW_MESSAGE_CATEGORY",
              },
            },
          },
          data: {
            icon: "ic_launcher",
            navigationTo: "ca-notification",
            content: bodyMsg.comments,
            did: param.car_id,
            cp_header: "car",
            request_id: param.request_id
          },
        };
        this.capSmsMail.pushNotificationFCM(pushObj);
      },
      (error) => {
        // Some task on failure
        console.log("APP-SERVICE-LIST-ERROR", error);
      }
    );
  }

  columnfilter() {
    console.log("::FILTER_COLUMN");
  }

  onSelectChange(value) {
    this.noOfItems = value;
    this.current_page = 1;
    this.changePage(this.current_page);
    this.pagenationNextToken = "";
    this.carReqlist = [];
    // this.noOfItems, this.pagenationNextToken
    //this.getAllData();
    this.getAllDataCarMaintance();
  }

  onNext() {
    this.currentIndex = (this.currentIndex + 5) % this.carReqlist.length;
    console.log("Next_currentIndex", this.currentIndex);
    this.loadData();
  }

  onPrevious() {
    this.currentIndex =
      (this.currentIndex - 5 + this.carReqlist.length) % this.carReqlist.length;
    console.log("previous_currentIndex", this.currentIndex);
    //this.loadData();
  }

  loadData() {
    // Call your API here based on the current index or perform other actions.
    console.log("Load data for index:", this.currentIndex);
    // You can access the current object in the array using this.costArray[this.currentIndex]
    //this.noOfItems, this.pagenationNextToken
    // this.getAllData();
    this.getAllDataCarMaintance();
  }

  listToMatrix(list, elementsPerSubArray) {
    var matrix = [],
      i,
      k;

    for (i = 0, k = -1; i < list.length; i++) {
      if (i % elementsPerSubArray === 0) {
        k++;
        matrix[k] = [];
      }

      matrix[k].push(list[i]);
    }

    return matrix;
  }

  getBeforeAfter(arr, index, count) {
    let start = index - count - 1;
    if (start < 0) start = 0;

    let end = index + count;

    return arr.slice(start, end);
  }

  getIndexes(arry, perSlice) {
    var ret = [];
    var i: any;
    for (i in arry) {
      ret.push(arry[i] == perSlice);
    }
    return ret;
  }

  goToPreviousPage() {
    console.log("goToPreviousPage", this.current_page, this.numPages());
    this.current_page--;

    this.changePage(this.current_page);

    // if (this.current_page > 1) {
    //   this.current_page--;
    //   console.log("goToPreviousPage 2");
    //   this.changePage(this.current_page);
    // }
  }

  goToNextPage() {
    // this.getAllData(this.noOfItems, this.pagenationNextToken);
    // this.current_page++;

    console.log("goToNextPage", this.current_page, this.numPages());

    // var matrixLen = this.listToMatrix(this.carReqlist, 5);
    // console.log("matrix",matrixLen);

    // var offset = this.carReqlist[2 % this.carReqlist.length];
    // console.log("offset", offset);

    // var indexes = this.getIndexes(this.carReqlist, 4);

    // console.log("indexes", indexes);

    if (!(this.current_page < this.numPages())) {
      console.log("GO_TO_NEXT_PAGE_API");
      // this.noOfItems, this.pagenationNextToken
      // this.getAllData();
      this.getAllDataCarMaintance();
      //  this.current_page++;
    }

    this.current_page++;
    this.changePage(this.current_page);
  }

  changePage(page) {
    // Validate page

    // this.carReqlist = [];
    // if (page < 1) page = 1;
    // if (page > this.numPages()) page = this.numPages();

    // var betweenRecord = this.getBeforeAfter(this.carReqlist, 1, 2);

    // console.log("Bet", betweenRecord);

    // for (
    //   var i = (page - 1) * this.noOfItems;
    //   i < page * this.noOfItems && i < this.carReqlist.length;
    //   i++
    // ) {
    //   // this.carReqlist.push(this.clientSideStore[i]);
    //   console.log("finalPrint", this.carReqlist);
    // }

    console.log("PAGE_NumPage", page, this.numPages());
    if (page == 1) {
      // btn_prev.style.visibility = "hidden";
      this.isprevBtn = true;
      console.log("prevBtnhidden");
      // if (this.pagenationNextToken != null) {
      //   this.getAllData(this.noOfItems, this.pagenationNextToken);
      // }
    } else {
      console.log("prevbtnvisible");
      // btn_prev.style.visibility = "visible";
      this.isprevBtn = false;
    }

    if (this.pagenationNextToken == null) {
      if (page == this.numPages()) {
        console.log("nextBtnhidden");
        // btn_next.style.visibility = "hidden";
        this.isnextBtn = true;
      } else {
        console.log("nextbtnvisible");
        //btn_next.style.visibility = "visible";
        this.isnextBtn = false;
        //this.getAllData(this.noOfItems, this.pagenationNextToken);
      }
    }
  }

  numPages() {
    console.log("NUM_PAGES", this.carReqlist.length / this.noOfItems);
    return Math.ceil(this.carReqlist.length / this.noOfItems);
  }

  paganationControl(val) {
    console.log("PARAM", val);
    var page = this.current_page;

    const gotoPreviousRecord = () => {
      if (this.current_page > 1) {
        this.current_page--;
        console.log("goToPreviousPage 2");
        //  this.changePage(this.current_page);
      }
    };

    const gotoNextRecord = () => {
      if (this.current_page < this.numPages()) {
        console.log("goToNextPage 2");
        this.current_page++;
        // this.changePage(this.current_page);
      }
    };

    switch (val) {
      case "previous":
        console.log("previous");
        gotoPreviousRecord();
        break;

      default:
        console.log("next");

        // Store the initial length
        this.storedRecordInitialLength = this.clientSideStore.length;

        console.log("initial_len", this.storedRecordInitialLength);
        console.log("store_data", this.clientSideStore);
        // ... Perform operations that may add new values to the array ...

        // Check if new values have been added
        if (this.storedRecordInitialLength > this.clientSideStore.length) {
          console.log("New values have been added to the array.");
          // Update the initial length for future checks
          this.storedRecordInitialLength = this.clientSideStore.length;
        } else {
          console.log("No new values have been added to the array.");
          //  this.noOfItems, this.pagenationNextToken
          //  this.getAllData();
          this.getAllDataCarMaintance();
          //gotoNextRecord();
        }

        break;
    }

    this.carReqlist = [];

    console.log("store::", this.clientSideStore.length);
    if (page < 1) page = 1;
    if (page > this.numPages()) page = this.numPages();

    for (
      var i = (page - 1) * this.noOfItems;
      i < page * this.noOfItems && i < this.clientSideStore.length;
      i++
    ) {
      this.carReqlist.push(this.clientSideStore[i]);
      console.log("finalPrint", this.clientSideStore);
    }

    console.log("PAGE_NumPage", page, this.numPages());
    if (page == 1) {
      // btn_prev.style.visibility = "hidden";
      this.isprevBtn = true;
      console.log("prevBtnhidden");
      // if (this.pagenationNextToken != null) {
      //   this.getAllData(this.noOfItems, this.pagenationNextToken);
      // }
    } else {
      console.log("prevbtnvisible");
      // btn_prev.style.visibility = "visible";
      this.isprevBtn = false;
    }

    if (page == this.numPages()) {
      console.log("nextBtnhidden");
      // btn_next.style.visibility = "hidden";

      this.isnextBtn = true;
      // if (this.pagenationNextToken == null) {
      //   this.isnextBtn = true;
      //   this.isPagenationFlag = true;
      // }
    } else {
      console.log("nextbtnvisible");
      //btn_next.style.visibility = "visible";
      this.isnextBtn = false;
      //this.getAllData(this.noOfItems, this.pagenationNextToken);
    }
  }
  // function nextPage()
  // {
  //     if (current_page < numPages()) {
  //         current_page++;
  //         changePage(current_page);
  //     }
  // }

  // goToPreviousPage() {
  //   var storeArraylen = this.clientSideStore.length;
  //   console.log("storeArraylen", storeArraylen);

  //   var itemsPerPage = 3;
  //   var perPage = storeArraylen / itemsPerPage;
  //   const startIndex = (perPage - 1) * itemsPerPage;
  //   const endIndex = startIndex + itemsPerPage;
  //   console.log("EndIndex", endIndex);
  // }

  // goToPreviousPage() {
  //   this.carReqlist = [];
  //   console.log("::storeDB", this.clientSideStore);
  //   if (this.index === 0) {
  //     this.index = this.clientSideStore.length;
  //   }
  //   this.index = this.index - 3;
  //   console.log(":::index", this.index);
  //   // console.clear();
  //   console.log(
  //     "prev array index:" + this.index,
  //     typeof this.index,
  //     this.clientSideStore
  //   );
  //   if (this.index <= 3 && this.index > 0) {
  //     console.log("insix");
  //     this.carReqlist = this.clientSideStore[this.index];
  //     //  this.nextB.disabled = false;
  //   } else {
  //     console.log("insix_2", this.clientSideStore);
  //     // for (let index = 0; index < this.clientSideStore.length; index++) {
  //     //   const element = this.clientSideStore[index] - 3;
  //     //   console.log(element-)

  //     // }
  //     // this.carReqlist.push(this.clientSideStore[this.index]);
  //     console.log("final value", this.clientSideStore[this.index] - 3);
  //     //  this.prevB.disabled = true;
  //   }
  // }
}
